module.exports = __webpack_public_path__ + "static/media/70s.854ab0d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/70s.png
// module id = 640
// module chunks = 0 1